var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { classMap } from 'lit/directives/class-map.js';
import { property, query, queryAssignedElements } from 'lit/decorators.js';
import { html, css } from 'lit';
import { customElement, stringDecoder, PICSelector, PICBase, PICOptionGroup } from '../Internals';
let PICDualSelector = class PICDualSelector extends PICBase {
    get submitValue() {
        var _a, _b, _c, _d;
        let sbmt = '';
        (_b = (_a = this.firstSelector[0].optionContainer) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.forEach(option => {
            sbmt = sbmt + option.key + ';';
        });
        sbmt = sbmt.slice(0, -1);
        sbmt = sbmt + '\x03';
        (_d = (_c = this.secondSelector[0].optionContainer) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.forEach(option => {
            sbmt = sbmt + option.key + ';';
        });
        sbmt = sbmt.slice(0, -1);
        return sbmt;
    }
    constructor() {
        super();
        this.label = '';
        this.selection = [];
        this.lastClicked = null;
        this.mouseDown = null;
        this.mouseUp = null;
        this.isDragging = false;
        this.validState = [];
        this.selectorsInserted = false;
        this.dragPreview = null;
        this.handleMouseUp = (e) => {
            if (e.target instanceof PICSelector && e.target !== this.mouseDown) {
                this.isDragging = true;
                this.mouseUp = e.target;
            }
            this.removeDragPreview();
            document.removeEventListener('mousemove', this.handleMouseMove);
            document.removeEventListener('mouseup', this.handleMouseUp);
        };
        this.handleMouseMove = (e) => {
            if (!this.dragPreview)
                return;
            this.dragPreview.style.left = `${e.clientX + 10}px`;
            this.dragPreview.style.top = `${e.clientY - 10}px`;
        };
    }
    static get styles() {
        const defaultStyle = css `
        :host{
           display: inline-block;
            --icon-disabled: var(--pic-outline);
            --icon-enabled: var(--pic-primaryMediumColor);
            --icon-hover: var(--pic-primaryColor);
            --button-border-color: var(--pic-primaryColor);
        }
        .container{
            display: flex;
            /* width: 100%;
            height: 100%; */
            align-items: center;
            justify-content: space-between;
        }
        .container > div{
            padding: 0 8px;
        }
        .transfer-btn{
            padding: 10px 0;
            height: 30px;
            width: 64px;
            font-family: "Material Design Icons";
            font-size: x-large;
            color: var(--icon-enabled);
            align-content: center;
        }
        .transfer-btn:focus{
            width: 60px;
            border-color: var(--button-border-color);
            border-width: 2px;
            border-radius: 4px;
            border-style: solid;
            height: 26px;
            outline: none;
        }
        .transfer-btn:not(.disabled):hover {
            color: var(--icon-hover);
        }
        
        .disabled {
            color: var(--icon-disabled);
            pointer-events: none;
            cursor: unset;
        }
        .arrow-left::before{
            content: '\u{F0CDD}';
            padding: 0 calc((64px - 24px)/2);
        }
        .arrow-right::before{
            content: '\u{F0CDF}';
            padding: 0 calc((64px - 24px)/2);
        }
        .arrow-left.transfer-btn:focus::before,
        .arrow-right.transfer-btn:focus::before {
            color: var(--icon-hover);
            padding: 0 calc((60px - 24px)/2);
        }
        `;
        return css `
        ${super.styles}
        ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        window.PIC.addInput(this.id_, this);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.PIC.removeInput(this.id_);
    }
    updated() {
        var _a, _b, _c;
        if (!this.selectorsInserted) {
            if ((_a = this.secondSelector[0]) === null || _a === void 0 ? void 0 : _a.id) {
                window.PIC.removeInput((_b = this.secondSelector[0]) === null || _b === void 0 ? void 0 : _b.id);
                window.PIC.removeInput((_c = this.firstSelector[0]) === null || _c === void 0 ? void 0 : _c.id);
                this.selectorsInserted = true;
            }
        }
    }
    handleKeys(e) {
        if (e.target instanceof PICSelector) {
            if (e.key === 'Enter') {
                if (this.selection.length > 0) {
                    let recipient = e.target === this.firstSelector[0] ? this.secondSelector[0] : this.firstSelector[0];
                    this.handleTransfer(e.target, recipient);
                }
            }
            else
                this.handleSelection(e.target);
        }
        if (e.target instanceof HTMLDivElement) {
            if (['Enter', ' '].includes(e.key))
                this.handleButtonPress(e.target);
        }
        this.requestUpdate();
    }
    handleClick(e) {
        if (this.isDragging) {
            this.handleDragDrop();
        }
        else {
            if (e.target instanceof PICSelector) {
                if (e.detail > 1) {
                    if (this.selection.length > 0) {
                        let recipient = e.target === this.firstSelector[0] ? this.secondSelector[0] : this.firstSelector[0];
                        this.handleTransfer(e.target, recipient);
                    }
                }
                else
                    this.handleSelection(e.target);
            }
            if (e.target instanceof HTMLDivElement) {
                this.handleButtonPress(e.target);
            }
        }
        this.requestUpdate();
    }
    createDragPreview() {
        if (this.selection.length === 0)
            return;
        this.dragPreview = document.createElement('div');
        this.dragPreview.className = 'drag-preview';
        this.dragPreview.style.cssText = `
            position: fixed;
            top: -100px;
            z-index: 10000;
            background: var(--pic-surfaceColor);
            border: 2px solid var(--pic-primaryColor);
            border-radius: 8px;
            padding: 8px 12px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.3);
            font-family: 'Montserrat';
            font-size: 14px;
            color: var(--pic-onSurfaceColor);
            pointer-events: none;
            max-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `;
        const previewText = this.selection.length === 1
            ? this.selection[0].val
            : `${this.selection.length} items`;
        this.dragPreview.textContent = previewText;
        document.body.appendChild(this.dragPreview);
    }
    removeDragPreview() {
        if (this.dragPreview) {
            document.body.removeChild(this.dragPreview);
            this.dragPreview = null;
        }
    }
    handleMouseDown(e) {
        this.isDragging = false;
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
        if (e.target instanceof PICSelector) {
            this.mouseDown = e.target;
            if (this.selection.length > 0) {
                this.createDragPreview();
                document.addEventListener('mousemove', this.handleMouseMove);
                document.addEventListener('mouseup', this.handleMouseUp);
            }
        }
    }
    deSelector(selector) {
        selector.selectedOption = undefined;
        let options = selector.selectorElem.options;
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected)
                options[i].selected = false;
        }
        selector.requestUpdate();
    }
    handleDragDrop() {
        if (this.selection.length > 0) {
            this.handleTransfer(this.mouseDown, this.mouseUp);
        }
        this.mouseDown = null;
        this.mouseUp = null;
        this.isDragging = false;
    }
    handleButtonPress(btn) {
        if (btn.classList.contains('transfer-btn') && !btn.classList.contains('disabled')) {
            if (this.selection.length > 0) {
                if (btn.classList.contains('arrow-left'))
                    this.handleTransfer(this.secondSelector[0], this.firstSelector[0]);
                if (btn.classList.contains('arrow-right'))
                    this.handleTransfer(this.firstSelector[0], this.secondSelector[0]);
            }
            btn.blur();
        }
    }
    handleSelection(selector) {
        this.validState.length = 0;
        if (this.selection.length > 0) {
            if (this.lastClicked && this.lastClicked !== selector)
                this.deSelector(this.lastClicked);
        }
        this.selection.length = 0;
        if (selector.submitValue.length > 0) {
            let optionKeys = selector.submitValue.split(';');
            let found;
            optionKeys.forEach(optKey => {
                found = selector.options.find(option => option.key === optKey);
                if (found)
                    this.selection.push(found);
            });
        }
        this.lastClicked = this.selection.length > 0 ? selector : null;
    }
    handleTransfer(donor, recipient) {
        let optionsToTransfer = [];
        this.selection.forEach(option => {
            var _a, _b;
            if (!((_b = (_a = recipient.optionContainer) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.has(option.key))) {
                if (!recipient.optionContainer) {
                    recipient.optionContainer = new PICOptionGroup();
                    recipient.optionContainer.componentRef = recipient;
                    recipient.appendChild(recipient.optionContainer);
                }
                optionsToTransfer.push(option);
                donor.optionContainer.removeOption(option);
            }
            else {
                let val1 = recipient.optionContainer.options.get(option.key);
                let val2 = donor.optionContainer.options.get(option.key);
                let err = { pass: false, failMessage: `Transfer failed - identical keys for ${val1 === null || val1 === void 0 ? void 0 : val1.val} and ${val2 === null || val2 === void 0 ? void 0 : val2.val} (${option.key})` };
                this.validState.push(err);
            }
        });
        recipient.optionContainer.addOptionArray(optionsToTransfer);
        this.deSelector(donor);
        this.deSelector(recipient);
        this.selection.length = 0;
        this.lastClicked = null;
    }
    getLabelClass() {
        return {
            'pic-caption': true,
            'disabled': this.disabled_
        };
    }
    getBtnClass(dir) {
        let disabled = true;
        if (this.lastClicked !== null) {
            if (dir === 'left' && this.lastClicked === this.secondSelector[0])
                disabled = false;
            if (dir === 'right' && this.lastClicked === this.firstSelector[0])
                disabled = false;
        }
        return {
            'disabled': disabled,
            'arrow-left': dir === 'left',
            'arrow-right': dir === 'right',
            'transfer-btn': true
        };
    }
    getBtnTabIndex(dir) {
        if (this.lastClicked !== null) {
            if (dir === 'left' && this.lastClicked === this.secondSelector[0])
                return 0;
            if (dir === 'right' && this.lastClicked === this.firstSelector[0])
                return 0;
        }
        return -1;
    }
    setComponentInlineStyle() {
        this.style.setProperty('width', 'fit-content');
    }
    renderErr() {
        return html `<pic-error .PICErrorData=${this.validState} .parent=${this.firstSelector[0]} .showErrorBox=${true}></pic-error>`;
    }
    render() {
        this.setComponentInlineStyle();
        return html `
        <label class=${classMap(this.getLabelClass())} for=${this.id}>${this.label}</label>
        <div class="container"
            @click=${this.handleClick}
            @keydown=${this.handleKeys}
            @mousedown=${this.handleMouseDown}
            @mouseup=${this.handleMouseUp}
        >
            <slot name="first-selector"></slot>
            <div>
                <div tabindex=${this.getBtnTabIndex('left')} class=${classMap(this.getBtnClass('left'))}></div>
                <div tabindex=${this.getBtnTabIndex('right')} class=${classMap(this.getBtnClass('right'))}></div>
            </div>
            <slot name="second-selector"></slot>
        </div>
        ${this.validState.length > 0 ? this.renderErr() : ''}
        `;
    }
};
__decorate([
    property({ converter: stringDecoder, attribute: 'label' })
], PICDualSelector.prototype, "label", void 0);
__decorate([
    queryAssignedElements({ slot: 'first-selector', selector: '*' })
], PICDualSelector.prototype, "firstSelector", void 0);
__decorate([
    queryAssignedElements({ slot: 'second-selector', selector: '*' })
], PICDualSelector.prototype, "secondSelector", void 0);
__decorate([
    query('.pic-errorContainer')
], PICDualSelector.prototype, "errCont", void 0);
PICDualSelector = __decorate([
    customElement('pic-dualselector')
], PICDualSelector);
export { PICDualSelector };
//# sourceMappingURL=PICDualSelector.js.map